// import React from "react";
// import { Navbar, NavbarBrand } from "reactstrap";
// import { Button } from "antd";
// import { NavLink as RouterNavLink } from "react-router-dom";
// import { Logo } from "../../Assets/Images";
// import UserBox from "./UserBox";
// import userServices from "../../UserServices/UserServices";
// import { RoutesService } from "../../Services";
// const MainNavbar = () => {
// 	const { tenant } = userServices.getCurrentUser();

// 	return (
// 		<div>
// 			<Navbar expand="md" className="py-0 shadow flex-nowrap">
// 				<NavbarBrand>
// 					<img src={Logo} height="40" alt="SurveyAuto" />
// 				</NavbarBrand>
// 				<div className="ml-auto d-flex align-items-center">
// 					{tenant === "BAT_SWITZERLAND" && (
// 						<Button className="mx-2">
// 							<RouterNavLink
// 								exact
// 								activeClassName="active"
// 								to={"/promotor-schedule"}
// 								target="_blank"
// 								rel="noopener noreferrer"
// 								style={{ textDecorationLine: "none" }}
// 							>
// 								Promotor Schedule
// 							</RouterNavLink>
// 						</Button>
// 					)}
// 					{tenant === "BAT_STATES" && (
// 						<Button className="mx-2">
// 							<RouterNavLink
// 								exact
// 								activeClassName="active"
// 								to={"/home"}
// 								target="_blank"
// 								rel="noopener noreferrer"
// 								style={{ textDecorationLine: "none" }}
// 							>
// 								Analysis
// 							</RouterNavLink>
// 						</Button>
// 					)}

// 					{tenant === "BAT_SWITZERLAND" && (
// 						<Button className="mx-2">
// 							<RouterNavLink
// 								exact
// 								activeClassName="active"
// 								to={"/ecommerce"}
// 								target="_blank"
// 								rel="noopener noreferrer"
// 								style={{ textDecorationLine: "none" }}
// 							>
// 								ECommerce
// 							</RouterNavLink>
// 						</Button>
// 					)}
// 					<Button className="mx-2">
// 						<RouterNavLink
// 							exact
// 							activeClassName="active"
// 							to={`${RoutesService.getRoleRoute("ADMIN")}`}
// 							target="_blank"
// 							rel="noopener noreferrer"
// 							style={{ textDecorationLine: "none" }}
// 						>
// 							Home
// 						</RouterNavLink>
// 					</Button>
// 					{tenant === "BAT_TENNESSEE" && (
// 						<Button className="mx-2">
// 							<RouterNavLink
// 								exact
// 								activeClassName="active"
// 								to={`/store-score`}
// 								target="_blank"
// 								rel="noopener noreferrer"
// 								style={{ textDecorationLine: "none" }}
// 							>
// 								Store Scoring
// 							</RouterNavLink>
// 						</Button>
// 					)}

// 					<UserBox />
// 				</div>
// 			</Navbar>
// 		</div>
// 	);
// };

// export default MainNavbar;

import React from "react";
import { Navbar, NavbarBrand } from "reactstrap";
import { Button } from "antd";
import { NavLink as RouterNavLink, useLocation } from "react-router-dom";
import { Logo } from "../../Assets/Images";
import UserBox from "./UserBox";
import userServices from "../../UserServices/UserServices";
import { RoutesService } from "../../Services";

const MainNavbar = () => {
	const { tenant } = userServices.getCurrentUser();
	const location = useLocation();

	// helper to test and render a button only if we're not already on its 'to' path
	const NavButton = ({ to, children }) =>
		location.pathname !== to ? (
			<Button className="mx-2">
				<RouterNavLink
					exact
					activeClassName="active"
					to={to}
					target="_blank"
					rel="noopener noreferrer"
					style={{ textDecoration: "none" }}
				>
					{children}
				</RouterNavLink>
			</Button>
		) : null;

	return (
		<Navbar expand="md" className="py-0 shadow flex-nowrap">
			<NavbarBrand>
				<img src={Logo} height="40" alt="SurveyAuto" />
			</NavbarBrand>
			<div className="ml-auto d-flex align-items-center">
				{tenant === "BAT_SWITZERLAND" && <NavButton to="/promotor-schedule">Promotor Schedule</NavButton>}

				{tenant === "BAT_STATES" && <NavButton to="/home">Analysis</NavButton>}

				{tenant === "BAT_SWITZERLAND" && <NavButton to="/ecommerce">ECommerce</NavButton>}

				<NavButton to={RoutesService.getRoleRoute("ADMIN")}>Home</NavButton>

				{tenant === "BAT_TENNESSEE" && <NavButton to="/store-score">Store Scoring</NavButton>}

				<UserBox />
			</div>
		</Navbar>
	);
};

export default MainNavbar;
